<template lang="pug">
.j-switch_btn(
  :class="isOpen?'open': ''",
  @click="switchChange"
)
  .switch-con
    .switch-status
  .switch-label.color_text_2 {{ label }}
</template>

<script>
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'JSwitchBtn',
  components: {
  },
  props: {
    isActive: Boolean,
    label: String,
  },
  setup(props, context) {
    const isOpen = ref(false);

    watch(() => props.isActive, (newValue) => {
      isOpen.value = newValue;
    });

    const switchChange = () => {
      isOpen.value = !isOpen.value;
      context.emit('j-switch', isOpen.value);
    };

    return {
      isOpen,
      switchChange,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.j-switch_btn
  font-size 0
  height 0.46rem
  line-height 0.46rem
  .switch-con
    display inline-block
    vertical-align middle
    width 0.56rem
    height 0.32rem
    line-height 0.32rem
    background rgba(200, 201, 204, 0.33)
    font-size 0
    margin-right 0.08rem
    border-radius 0.16rem
    .switch-status
      display inline-block
      vertical-align middle
      width 0.28rem
      height 0.28rem
      background #C8C9CC
      border-radius 50%
  .switch-label
    display inline-block
    vertical-align middle
    font-size 0.28rem
    line-height 0.34rem
.j-switch_btn.open
  .switch-con
    background #E1EBFF
    text-align right
    .switch-status
      background #4D71FF
</style>
<style lang="stylus" scoped>
  .dark
    .j-switch_btn
      .switch-con
        background rgba(56, 56, 57, 0.5);
        .switch-status
          background #383839
    .j-switch_btn.open
      .switch-con
        background #132440
        .switch-status
          background #4D71FF
</style>
